import React from 'react';
import { Link } from 'react-router-dom';
import { Film, ArrowRight, Play } from 'lucide-react';
import { VIDEO_CLIPS } from '../data';

export const VideosSection = () => (
  <section id="videos" className="bg-[#050505] section-spacing" data-testid="hyrox-videos-section">
    <div className="container-ninja">
      <div className="max-w-5xl mx-auto">
        <p className="text-[#e8ff00] text-xs uppercase tracking-wider font-heading mb-3 flex items-center gap-2">
          <Film className="w-4 h-4" /> Cinematic HYROX
        </p>
        <h2 className="text-3xl md:text-4xl text-white font-heading mb-4">RACE FILMS &amp; HYPE REELS</h2>
        <p className="text-zinc-400 mb-8 max-w-2xl">
          Experience HYROX through cinematic lenses. Race recaps, hype reels, and event films from our creative team.
        </p>

        <div className="grid grid-cols-3 gap-4 mb-8">
          {VIDEO_CLIPS.map((v) => (
            <div
              key={v.id}
              className="group relative aspect-video bg-zinc-900 border border-zinc-800 overflow-hidden cursor-pointer hover:border-[#e8ff00]/40 transition-all"
              data-testid={`hyrox-vid-${v.id}`}
              onClick={(e) => {
                const vid = e.currentTarget.querySelector('video');
                if (vid) { vid.paused ? vid.play().catch(() => {}) : vid.pause(); }
              }}
            >
              <video
                src={v.src}
                muted
                loop
                playsInline
                preload="metadata"
                className="w-full h-full object-cover"
                onMouseEnter={(e) => e.target.play().catch(() => {})}
                onMouseLeave={(e) => { e.target.pause(); e.target.currentTime = 0; }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none">
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="text-[#e8ff00] text-[9px] uppercase tracking-wider font-heading">{v.cat}</span>
                  <p className="text-white text-xs font-heading mt-0.5">{v.title}</p>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-60 group-hover:opacity-0 transition-opacity">
                  <Play className="w-8 h-8 text-white/60" fill="currentColor" />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="border border-[#e8ff00]/20 bg-[#e8ff00]/5 p-6 flex flex-col md:flex-row items-center justify-between gap-4" data-testid="content-cta">
          <div>
            <h3 className="text-white font-heading text-lg">WANT CINEMATIC HYROX CONTENT?</h3>
            <p className="text-zinc-400 text-sm mt-1">Professional race films, hype reels, and athlete profiles for your social media.</p>
          </div>
          <Link to="/hyrox-content" className="flex-shrink-0 px-6 py-3 bg-[#e8ff00] text-black font-heading text-sm uppercase tracking-wider hover:opacity-90 transition-opacity inline-flex items-center gap-2" data-testid="content-page-cta-btn">
            Learn More <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
